/* Kindly cart page: quantity, remove, discount codes and sorting.
   Uses the Cart AJAX API with Section Rendering, so the page and the header cart count
   are re-rendered by Shopify (no prices are calculated in the browser). */
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var sectionId = root.dataset.section;
    var sortSel = root.querySelector('[data-kcart-sort]');
    var sortWrap = root.querySelector('[data-kcart-sort-wrap]');
    var busy = false;

    function sections() { return [sectionId, 'cart-icon-bubble']; }

    function applySort() {
      var list = root.querySelector('[data-kcart-list]');
      if (!list || !sortSel) return;
      var items = Array.prototype.slice.call(list.children);
      var mode = sortSel.value;
      items.sort(function (a, b) {
        if (mode === 'oldest') return b.dataset.index - a.dataset.index;
        if (mode === 'name') return a.dataset.title.localeCompare(b.dataset.title);
        if (mode === 'qty') return b.dataset.qty - a.dataset.qty;
        return a.dataset.index - b.dataset.index; // Shopify lists the latest added first
      });
      items.forEach(function (li) { list.appendChild(li); });
    }

    function render(data) {
      if (!data || !data.sections) return;
      var html = data.sections[sectionId];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextBody = doc.querySelector('[data-kcart-body]');
        var empty = !doc.querySelector('[data-kcart-list]');
        var body = root.querySelector('[data-kcart-body]');
        if (nextBody && body) body.replaceWith(nextBody);
        if (sortWrap) sortWrap.hidden = empty;
      }
      var bubble = data.sections['cart-icon-bubble'];
      var icon = document.getElementById('cart-icon-bubble');
      if (bubble && icon) {
        var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
        if (b) icon.innerHTML = b.innerHTML;
      }
      applySort();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kindly-cart', cartData: data });
      }
    }

    function post(url, body) {
      body.sections = sections();
      body.sections_url = window.location.pathname;
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; }
          return j;
        });
      });
    }

    function changeLine(li, qty) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      var err = li.querySelector('.kcart__error');
      if (err) err.hidden = true;
      post(root.dataset.changeUrl, { line: parseInt(li.dataset.line, 10), quantity: qty })
        .then(render)
        .catch(function (e) {
          if (err) { err.textContent = e.message; err.hidden = false; }
        })
        .finally(function () { busy = false; root.classList.remove('is-loading'); });
    }

    function setPromoMsg(text, kind) {
      var msg = root.querySelector('[data-kcart-promo-msg]');
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'kcart__promo-msg' + (kind ? ' is-' + kind : '');
    }

    function currentCodes() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-kcart-remove-code]')).map(function (b) {
        return b.dataset.kcartRemoveCode;
      });
    }

    function updateCodes(codes, onDone) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      post(root.dataset.updateUrl, { discount: codes.join(',') })
        .then(function (data) { render(data); onDone(data); })
        .catch(function (e) { setPromoMsg(e.message, 'error'); })
        .finally(function () { busy = false; root.classList.remove('is-loading'); });
    }

    root.addEventListener('click', function (e) {
      var li = e.target.closest('.kcart__item');
      var step = e.target.closest('[data-kcart-step]');
      if (li && step) {
        var q = parseInt(li.dataset.qty, 10) + parseInt(step.dataset.kcartStep, 10);
        changeLine(li, Math.max(0, Math.min(999, q)));
        return;
      }
      if (li && e.target.closest('[data-kcart-remove]')) { changeLine(li, 0); return; }

      var rm = e.target.closest('[data-kcart-remove-code]');
      if (rm) {
        var code = rm.dataset.kcartRemoveCode;
        updateCodes(currentCodes().filter(function (c) { return c !== code; }), function () {
          setPromoMsg(root.dataset.msgRemoved, '');
        });
      }
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-kcart-promo]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = (input.value || '').trim();
      if (!code) return;
      var codes = currentCodes();
      if (codes.indexOf(code) === -1) codes.push(code);
      updateCodes(codes, function (data) {
        var found = (data.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (found && found.applicable) setPromoMsg(root.dataset.msgApplied.replace('[code]', found.code), 'ok');
        else {
          setPromoMsg(root.dataset.msgInvalid, 'error');
          // drop the code that did not apply so it does not linger on the cart
          if (found) post(root.dataset.updateUrl, { discount: codes.filter(function (c) { return c !== code; }).join(',') }).then(function (d) { render(d); setPromoMsg(root.dataset.msgInvalid, 'error'); }).catch(function () {});
        }
      });
    });

    if (sortSel) {
      sortSel.addEventListener('change', applySort);
      applySort();
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-kcart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
